export enum PhItemLinesObjectTypeEnum{
    BOX ='BOX',
    ROLL ='ROLL',
    BALE ='BALE',
}